<template>
  <div :class="['team-grid container-fluid bg-color', className]">
    <div class="wrapper-fixed">
      <div class="row">
        <div class="col-12 col-lg-8">
          <div :id="sectionID" class="section-name">Team</div>
          <h2>The People Behind OUR Solutions</h2>
          <p>Our team is the driving force behind FCG Ecommerce Solutions. With expertise spanning leadership, software development, marketing, and content creation, we bring together a diverse group of professionals dedicated to helping our sister companies succeed. Each member contributes unique skills and a shared commitment to delivering innovative, efficient, and impactful eCommerce and marketing solutions.</p>
          <ul id="team-grid-nav" class="mt-6 mb-2">
            <li v-for="filter in filters" :key="filter">
              <button @click="filterTeam($event, filter)" :class="['btn', 'btn-sm', 'btn-secondary', { active: activeFilter === filter }]">
                {{ filter }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div id="team-grid-wrapper" :class="['bg-color', className]">
      <transition-group tag="ul" name="team" appear id="team-grid-photos">
      <li class="team-member-show" data-teams="Leadership,Marketing" key="nikki-t">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Nikki T.">
          <img src="@/assets/images/NikkiT-Headshot-2025.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Nikki T.</span>
            <span class="xxs-type weight-normal d-block">Vice President of eCommerce</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Leadership,Software" key="ben-m">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Ben M.">
          <img src="@/assets/images/Ben_Mills_Headshot_1.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Ben M.</span>
            <span class="xxs-type weight-normal d-block">Vice President of Software Engineering</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Marketing" key="holly-m">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Holly M.">
          <img src="@/assets/images/NikkiT-Headshot-2025.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Holly M.</span>
            <span class="xxs-type weight-normal d-block">Marketing</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Software" key="corey-m">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Corey M.">
          <img src="@/assets/images/Ben_Mills_Headshot_1.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Corey M.</span>
            <span class="xxs-type weight-normal d-block">Software</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Web Content" key="nancy-p">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Nancy P.">
          <img src="@/assets/images/NikkiT-Headshot-2025.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Nancy P.</span>
            <span class="xxs-type weight-normal d-block">Marketing</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Web Content" key="jack-w">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Jack W.">
          <img src="@/assets/images/Ben_Mills_Headshot_1.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Jack W.</span>
            <span class="xxs-type weight-normal d-block">Software</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Software" key="melissa-k">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Melissa K.">
          <img src="@/assets/images/Ben_Mills_Headshot_1.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Melissa K.</span>
            <span class="xxs-type weight-normal d-block">Software</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Marketing" key="dannie-e">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Dannie E.">
          <img src="@/assets/images/NikkiT-Headshot-2025.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Dannie E.</span>
            <span class="xxs-type weight-normal d-block">Marketing</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Software" key="mike-d">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Mike D.">
          <img src="@/assets/images/Ben_Mills_Headshot_1.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Mike D.</span>
            <span class="xxs-type weight-normal d-block">Software</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Web Content" key="dwight-y">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Dwight Y.">
          <img src="@/assets/images/Ben_Mills_Headshot_1.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Dwight Y.</span>
            <span class="xxs-type weight-normal d-block">Web Content</span>
          </span>
        </button>
      </li>
      <li class="team-member-show" data-teams="Web Content" key="marge-s">
        <button type="button" data-bs-toggle="modal" data-bs-target="#team-sample" aria-label="Marge S.">
          <img src="@/assets/images/NikkiT-Headshot-2025.jpg" alt="TODO" width="750" height="915">
          <span class="team-grid-teaser">
            <span class="xl-type weight-bold d-block">Marge S.</span>
            <span class="xxs-type weight-normal d-block">Web Content</span>
          </span>
        </button>
      </li>
    </transition-group>
    </div>
  
  
  <div class="modal fade" id="team-sample" tabindex="-1" aria-labelledby="modal-team-name" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"><i class="bi bi-x-circle-fill"></i></button>
        <div class="modal-body p-0">
          <div class="row align-items-center m-0">
            <div class="col-12 col-sm-6 p-0 team-modal-photo">
              <img src="@/assets/images/NikkiT-Headshot-2025.jpg" alt="TODO" class="img-fluid">
            </div>
            <div class="col-12 col-sm-6 p-0">
              <div class="p-6">
                <h2 class="content-label mb-0">Our Team</h2>
                <h3 id="modal-team-name">First L.</h3>
                <div class="sm-type weight-bold transform-uppercase mb-2">Team Member's Title Goes Here</div>
                <ul>
                  <li>At FCG Ecommerce Solutions since 2005</li>
                  <li>BS, Mechanical Engineering</li>
                  <li>Enjoys staying active with golf in the summer and snowboarding in the winter</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "BlockTeamGrid",
    props: {
      className: [String, Array],
      sectionID: String,
    },
  
    data() {
      return {
        activeFilter: "all", // Default filter is 'all'
        filters: ["all", "Leadership", "Software", "Marketing", "Web Content"], // Available categories
        isFiltering: false, // Prevents new filter selection until transitions complete
      };
    },
  
    methods: {
      /**
       * Adjusts the height of the #team-grid-photos container smoothly.
       */
       
      adjustContainerHeight() {
          const teamGridWrapper = document.getElementById("team-grid-wrapper");
          const teamGridPhotos = document.getElementById("team-grid-photos");
      
          if (!teamGridWrapper || !teamGridPhotos) return;
      
          // Get new height of #team-grid-photos
          const newHeight = teamGridPhotos.offsetHeight;
          teamGridWrapper.style.height = `${newHeight}px`;
      
          // Ensure height is correct when the transition completes
          setTimeout(() => {
              teamGridWrapper.style.height = `${newHeight}px`;
          }, 250);
      },
      
      /**
       * Debounced resize handler to adjust container height.
       */
       
      handleResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.adjustContainerHeight();
        }, 200); // Adjust debounce timing as needed
      },
  
      /**
       * Handles filtering when a button is clicked.
       * @param {Event} event - The click event.
       * @param {String} filter - The selected filter.
       */
       
      filterTeam(event, filter) {
        if (this.isFiltering || filter === this.activeFilter) return; // Prevent multiple clicks
  
        this.isFiltering = true; // Prevent another filter click during animation
  
        const buttons = document.querySelectorAll("#team-grid-nav button");
        const teamMembers = document.querySelectorAll("#team-grid-photos li");
  
        // Step 1: Remove 'selected' class from all buttons before transition starts
        buttons.forEach((btn) => btn.classList.remove("selected"));
  
        // Add 'active' class to indicate filtering is in progress
        if (event && event.target) {
          event.target.classList.add("active");
        }
  
        // Step 2: Ensure the "team-member-show" class is applied immediately to all items that will be shown
        teamMembers.forEach((member) => {
          const teams = member.getAttribute("data-teams").toLowerCase().split(",").map(t => t.trim());
          if (filter === "all" || teams.includes(filter.toLowerCase())) {
            member.classList.add("team-member-show"); // Ensure all relevant items have this class early
          }
        });
  
        // Step 3: Hide currently visible team members
        teamMembers.forEach((member) => {
          const teams = member.getAttribute("data-teams").toLowerCase().split(",").map(t => t.trim());
          if (this.activeFilter === "all" || teams.includes(this.activeFilter.toLowerCase())) {
            member.classList.remove("team-member-showing", "team-member-show", "team-member-hidden");
            member.classList.add("team-member-hide");
          }
        });
  
        // Step 4: Move "team-member-hide" members to "team-member-hidden"
        setTimeout(() => {
          teamMembers.forEach((member) => {
            const teams = member.getAttribute("data-teams").toLowerCase().split(",").map(t => t.trim());
            if (!teams.includes(filter.toLowerCase()) && filter !== "all") {
              member.classList.remove("team-member-hide");
              member.classList.add("team-member-hidden");
            }
          });
  
          // Step 5: After another 0.25s, make the "team-member-hidden" members visible with "team-member-show"
          setTimeout(() => {
            teamMembers.forEach((member) => {
              const teams = member.getAttribute("data-teams").toLowerCase().split(",").map(t => t.trim());
              if (filter === "all" || teams.includes(filter.toLowerCase())) {
                member.classList.remove("team-member-hidden", "team-member-hide");
                member.classList.add("team-member-show");
              }
            });
  
            // Step 6: Adjust the height smoothly
            this.adjustContainerHeight();
  
            // Step 7: After another 0.25s, finalize transition by moving "team-member-show" to "team-member-showing"
            setTimeout(() => {
              teamMembers.forEach((member) => {
                const teams = member.getAttribute("data-teams").toLowerCase().split(",").map(t => t.trim());
                if (filter === "all" || teams.includes(filter.toLowerCase())) {
                  member.classList.remove("team-member-show", "team-member-hide");
                  member.classList.add("team-member-showing");
                }
              });
  
              // Step 8: Unlock scroll AFTER all transitions complete
              setTimeout(() => {
                this.isFiltering = false; // Allow new filter selection
  
                // Remove "active" class & add "selected" class to the final filter button
                buttons.forEach((btn) => btn.classList.remove("active"));
                const selectedButton = [...buttons].find(btn => btn.textContent.trim() === filter);
                if (selectedButton) selectedButton.classList.add("selected");
  
              }, 250);
  
              // Update the active filter AFTER all transitions complete
              this.activeFilter = filter;
  
            }, 250); // Delay before switching "show" to "showing"
  
          }, 250); // Delay before switching "hidden" to "show"
  
        }, 250); // Delay before switching "hide" to "hidden"
      }
    },
  
    mounted() {
      // Ensure all team members start with 'team-member-show'
      document.querySelectorAll("#team-grid-photos li").forEach((member) => {
        member.classList.add("team-member-show");
      });
  
      // Ensure "All" button starts as selected
      const allButton = [...document.querySelectorAll("#team-grid-nav button")]
        .find(btn => btn.textContent.trim().toLowerCase() === "all");
  
      if (allButton) allButton.classList.add("selected");
  
      // Set initial height after everything loads
      window.addEventListener("resize", this.handleResize);
    },
    
    beforeUnmount() {
      window.removeEventListener("resize", this.handleResize);
    },
  };
</script>